// 文件管理
import Layout from "@/layout";

const fileManagementRoute = [
  {
    path: "/files",
    component: Layout,
    redirect: "/files/internal",
    name: "files",
    alwaysShow: true,
    meta: {
      title: "文件管理",
      icon: "wenjian",
      roles: ["ROLE_STAFF"]
    },
    children: [
      {
        path: "internal",
        component: () => import("@/views/files/internalFiles"),
        name: "internal",
        meta: {
          title: "内部文件",
          icon: "wenjian-2"
        }
      },
      {
        path: "external",
        component: () => import("@/views/files/externalFiles"),
        name: "external",
        meta: {
          title: "外部文件",
          icon: "buoumaotubiao37"
        }
      },
      {
        path: "filesSarchNew",
        name: "filesSarchNew",
        component: () => import("@/views/files/filesSarchNew"),
        meta: {
          title: "外部文件标准查新【查看】",
          icon: "user"
        }
      },
      {
        path: "addSarchNew",
        name: "addSarchNew",
        component: () => import("@/views/files/addSarchNew"),
        meta: {
          title: "外部文件标准查新【申请】",
          icon: "user"
        }
      },
      {
        path: "external-index",
        component: () => import("@/views/taskCenter/external/index"),
        name: "externalIndex",
        meta: {
          title: "外部文件标准查新【审批】",
          icon: "check-result"
        }
      },
      {
        path: "internalFilesLook",
        name: "internalFilesLook",
        component: () => import("@/views/files/internalFilesLook"),
        meta: {
          title: "内部文件查看",
          icon: "user"
        },
        hidden: true
      },
      {
        path: "view-external",
        component: () => import("@/views/process/external/add"),
        name: "viewExternal",
        meta: {
          title: "审批-文件查新",
          icon: "yiqi",
          noCache: true
        }
      },
      {
        path: "view-external-externalInfo",
        component: () => import("@/views/process/external/externalInfo"),
        name: "externalInfo",
        meta: {
          title: "审批-文件查新详情",
          icon: "yiqi",
          noCache: true
        }
      }
    ]
  }
];

export default fileManagementRoute;



// WEBPACK FOOTER //
// ./src/router/modules/filesManagement.js